import { Instance, types, flow } from "mobx-state-tree";
import axios from "axios";
import { STUDENTS_API } from "@constants/api";
import { AlertResultApi } from "@utils/alert";
import { Pagination } from "./Pagination";
import { jsonParsePagination } from "@utils/format";
import { FetchingEnum } from "./Fetching";

export const initialStatestudents = {
  fetching: "done",
  fetchingStudent: "done",
  fetchingAdd: "done",
  fetchingUpdate: "done",
};

const student = types.model({
  id: types.number,
  schoolId: types.number,
  levelId: types.number,
  levelGroupId: types.maybeNull(types.number),
  firstName: types.string,
  lastName: types.string,
  gender: types.string,
  macAddress: types.maybeNull(types.string),
  dateOfBirth: types.string,
  parent: types.model({
    id: types.number,
    email: types.string,
    salutation: types.string,
    firstName: types.string,
    lastName: types.string,
    mobile: types.string,
  }),
  status: types.string,
  createdAt: types.string,
  updatedAt: types.maybeNull(types.string),
  uniqueCode: types.maybeNull(types.string),
  photoUrl: types.maybeNull(types.string),
  medicalCondition: types.maybeNull(types.string),
});

export const Students = types
  .model({
    students: types.maybeNull(types.array(student)),
    paginationStudent: types.maybeNull(Pagination),
    detailStudent: types.maybeNull(student),
    fetching: types.string,
    fetchingStudent: types.string,
    fetchingAdd: types.string,
    status: types.maybeNull(types.number),
    fetchingUpdate: types.string,
  })
  .actions((self) => ({
    getStudents: flow(function* getStudents(
      token: string,
      ParentId: number,
      pageNumber: number
    ) {
      self.fetchingStudent = "pending";
      self.students = null;
      self.paginationStudent = null;
      try {
        // ... yield can be used in async/await style
        const result = yield axios.get(STUDENTS_API, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            Filter: JSON.stringify({ parentId: ParentId }),
            PageSize: 10,
            PageNumber: pageNumber,
          },
        });
        console.log(result);
        self.fetchingStudent = "done";
        self.paginationStudent = jsonParsePagination(
          result.headers["x-pagination"]
        );
        self.status = result.status;
        self.students = result.data;
      } catch (error) {
        // ... including try/catch error handling
        console.error("Failed to fetch projects", error);
        self.status = error?.response?.status || 500;
        self.fetchingStudent = FetchingEnum.ERROR;
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message
        );
      }
    }),
    getDetailStudent: flow(function* getDetailStudent(
      token: string,
      studentId: string,
      callback: (x: StudentType) => void
    ) {
      self.fetching = "pending";
      self.detailStudent = null;
      try {
        // ... yield can be used in async/await style
        const result = yield axios.get(`${STUDENTS_API}/${studentId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log(result);
        self.fetching = "done";
        self.status = result.status;
        self.detailStudent = result.data;
        callback(result.data);
        // self.invoices = result.data
      } catch (error) {
        // ... including try/catch error handling
        console.error("Failed to fetch projects", error);
        self.status = error?.response?.status || 500;
        self.fetching = FetchingEnum.ERROR;
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message
        );
      }
    }),
    postAddStudent: flow(function* postAddStudent(
      token: string,
      data: RegisterStudentType,
      callback: () => void
    ) {
      self.fetchingAdd = "pending";
      try {
        // ... yield can be used in async/await style
        const result = yield axios.request({
          method: "post",
          url: STUDENTS_API,
          headers: { Authorization: `Bearer ${token}` },
          data: data,
        });
        console.log(result);
        self.fetchingAdd = "done";
        self.status = result.status;
        callback();
      } catch (error) {
        // ... including try/catch error handling
        console.error("Failed to fetch projects", error);
        self.status = error?.response?.status || 500;
        self.fetchingAdd = FetchingEnum.ERROR;
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message
        );
      }
    }),
    updateStudent: flow(function* postAddStudent(
      token: string,
      studentId: string,
      data: UpdateStudentType,
      callback: () => void
    ) {
      self.fetchingUpdate = "pending";
      try {
        // ... yield can be used in async/await style
        const result = yield axios.request({
          method: "put",
          url: `${STUDENTS_API}/${studentId}`,
          headers: { Authorization: `Bearer ${token}` },
          data: data,
        });
        console.log(result);
        self.fetchingUpdate = "done";
        self.status = result.status;
        callback();
      } catch (error) {
        // ... including try/catch error handling
        console.error("Failed to fetch projects", error);
        self.status = error?.response?.status || 500;
        self.fetchingUpdate = FetchingEnum.ERROR;
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message
        );
      }
    }),
  }));

export type StudentsType = Instance<typeof Students>;
export type StudentType = Instance<typeof student>;
